// ~/context/store-context.tsx
import React, { createContext, useContext, useState, useEffect } from 'react';

interface StoreContextType {
    selectedStore: string;
    setSelectedStore: (store: string) => void;
}

const StoreContext = createContext<StoreContextType | undefined>(undefined);

interface StoreProviderProps {
    children: React.ReactNode;
    initialStore: string;
}

export const StoreProvider: React.FC<StoreProviderProps> = ({ children, initialStore }) => {
    const [selectedStore, setSelectedStore] = useState<string>(initialStore);

    // Whenever the store changes, update the cookie.
    useEffect(() => {
        document.cookie = `selectedStore=${encodeURIComponent(selectedStore)}; path=/; max-age=${60 * 60 * 24 * 365}`;
    }, [selectedStore]);

    return (
        <StoreContext.Provider value={{ selectedStore, setSelectedStore }}>
            {children}
        </StoreContext.Provider>
    );
};

export const useStore = () => {
    const context = useContext(StoreContext);
    if (!context) {
        throw new Error("useStore must be used within a StoreProvider");
    }
    return context;
};

// Safe version that returns a default instead of throwing — use in components
// that may render outside StoreProvider during SSR (e.g. footer)
export const useStoreSafe = () => {
    const context = useContext(StoreContext);
    return context || { selectedStore: 'catalystbellflower', setSelectedStore: () => {} };
};
